import React from 'react';
import '../styles/ErrorMessage.css';

function ErrorMessage(props) {
  return <div {...props} className="ErrorMessage pa3 lh-copy" />;
}

export default ErrorMessage;
